module.exports = __webpack_public_path__ + "img/info.7179c26b.svg";